import React, {useEffect} from "react"
import {Switch, Route} from "react-router-dom"
import classnames from "classnames"

import {observer} from "mobx-react"

import XsSnackbar from "./global/ui/xsSnackbar/xsSnackbar"
// import XsButton from "./global/ui/xsButton/xsButton"
import XsHeader from "./global/ui/xsHeader/xsHeader"
import XsFooter from "./global/ui/xsFooter/xsFooter"
import XsLoading from "./global/ui/xsLoading/xsLoading"

import LoginContainer from "./modules/login/loginContainer"
import Register from "./modules/login/register"
import RequestForm from "./modules/RequestForm/RequestForm"
import RegisterContainer from "./modules/login/registerContainer"
import AllocationsContainer from "./modules/allocations/allocationsContainer"
import SettingsContainer from "./modules/settings/settingsContainer"
import ResetPasswordContainer from "./modules/login/resetPasswordContainer"
import XsInfoDialog from "./global/ui/xsDialog/xsInfoDialog"
import XsErrorDialog from "./global/ui/xsDialog/xsErrorDialog"
import XsConfirmationDialog from "./global/ui/xsDialog/xsConfirmationDialog"

import Requests from "./modules/requests/requests"

import InfoStore from "./global/store/InfoStore"
import ErrorStore from "./global/store/ErrorStore"
import RouterStore from "./global/store/RouterStore"
import GlobalStore from "./global/store/GlobalStore"
import RegistersCacheStore from "./global/store/RegistersCacheStore"

import {getUser, logout, echo} from "./global/helpers/actions"

import "./global/styles/global.less"
// import MainContainer from "./modules/main/mainContainer"
import XsPublicHeader from "./global/ui/xsHeader/xsPublicHeader"
import {injectIntl} from "react-intl"

function App() {
	const user = getUser()
	const id = new URLSearchParams(RouterStore.location.search).get("id")

	useEffect(() => {
		GlobalStore.loadCodelist(RouterStore.location.pathname)
	}, [RouterStore.location.pathname])

	useEffect(() => {
		if (
			isEmpty(user) &&
			RouterStore.location.pathname != "/" &&
			RouterStore.location.pathname != "/login" &&
			RouterStore.location.pathname != "/register" &&
			RouterStore.location.pathname != "/registerFinish" &&
			RouterStore.location.pathname != "/passwordResetFinish"
		) {
			RouterStore.push("/login")
		}
	}, [RouterStore.location.pathname])

	return (
		<div
			id="app"
			className={classnames({
				"main-bg": RouterStore.location.pathname == "/requests"
			})}
		>
			{isSafe(user) ? (
				<Switch>
					<Route
						exact
						path="/"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<Requests {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/login"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<LoginContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/register"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<Register {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/registerFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<RegisterContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/passwordResetFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<ResetPasswordContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/request"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="secondary_container">
									<RequestForm id={id} {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/requests"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<Requests {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/allocations"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<AllocationsContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/settings"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<SettingsContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
				</Switch>
			) : (
				<Switch>
					<Route
						exact
						path="/"
						render={(props) => (
							<React.Fragment>
								{/* <XsPublicHeader /> */}
								<main className="main_container">
									<LoginContainer {...props} />
									{/* <MainContainer {...props} /> */}
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/login"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<LoginContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/register"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<Register {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/registerFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<RegisterContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/passwordResetFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<ResetPasswordContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
				</Switch>
			)}
			<XsSnackbar />
			{(GlobalStore.isLoading || RegistersCacheStore.registersLoading) && <XsLoading overlay />}
			{ErrorStore.isOpen && <XsErrorDialog />}
			{InfoStore.isOpen && <XsInfoDialog />}
			<XsConfirmationDialog
				name="xsWarningTokenExpired"
				text={`Platnosť vášho prihlásenia vyprší o ${GlobalStore.countdownExpireToken} sekúnd!`}
				confirmBtn={{
					icon: <i className="fal fa-check" />,
					text: "Common.btn.renew"
				}}
				cancelBtn={{
					icon: <i className="fal fa-times" />,
					text: "Common.btn.logout"
				}}
				onConfirmation={() => {
					echo()
				}}
				onCancel={() => {
					logout()
				}}
			/>
		</div>
	)
}

export default injectIntl(observer(App))

